module.exports = __webpack_public_path__ + "media/images/front/dplus_banner_movie_240613-3a6ee9f30f6557a43f27960d8ef53c51.jpeg";